import { h, render } from "preact";

export const Image = ({src, sizes, alt}) => {
  
  return (
    <picture>
      {sizes[1] &&
        <source data-srcset={ resizeImageSrcset(src, sizes[1]) }
                media="(max-width: 767px)"
                srcSet={ theme.placeholder_data }/>
      }
      <source data-srcset={ resizeImageSrcset(src, sizes[0]) }
              srcSet={ theme.placeholder_data }/>
      <img data-src={ resizeImage(src, sizes[0]) } className="lazyload" data-sizes="auto"
           alt={ alt }
           src={ theme.placeholder_data }/>
    </picture>
  )
}
